import styled from 'styled-components'

export const HeaderWrapper = styled.div`
  margin-bottom: 16px;
`